import * as types from '../mutation-types'

export default {
	namespaced: true,
	
	state: {
		categories: []
	},

	actions: {
		fetchAll ({ commit }) {
			return window.axios.get('/categories').then(({ data }) => {
				commit(types.STORE_CATEGORIES, data)
				return data
			})
		},

		create ({ commit }, { name, parentId }) {
			return window.axios.post('/categories', { name, parentId }).then(({ data }) => { 
				return data 
			})
		},

		update ({ commit }, { name, parentId, id }) {
			return window.axios.put(`/categories/${id}`, { name, parentId }).then(({ data }) => {
				return data
			})
		},

		delete ({ commit }, { id }) {
			return window.axios.delete(`categories/${id}`)
		},

		fetchDirectChildren ({ commit }, { categoryId }) {
			return window.axios.get('/Categories/DirectChildren', { params: { categoryId } }).then(({ data }) => {
				return data
			})
		}
	},
	mutations: {
		[types.STORE_CATEGORIES] (state, categories) {
			state.categories = categories
		}
	},
	
	getters: {
		getCategoryById: state => id => state.categories.find(c => c.id === id) 
	}
}
